export var equalByJsonSnapshot = function (a, b) {
    return JSON.stringify(a) === JSON.stringify(b);
};
export var equalByString = function (a, b) { return a + '' === b + ''; };
export var equalById = function (a, b) {
    if (!a && !b)
        return true;
    if (!a || !b)
        return false;
    return equalByString(a.id, b.id);
};
export var strictEqual = function (a, b) { return a === b; };
